import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SigninComponent } from './signin/signin.component'; 
import { ToastrModule } from 'ngx-toastr';
import { PoHeaderComponent } from './layout/po-header/po-header.component';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { LayoutComponent } from './layout/layout.component'; 
import { DateFormatPipe } from './pipes/date-format.pipe';
import { DragDropDirective } from './drag-drop.directive';
import { CreatepurchaseComponent } from './layout/createpurchase/createpurchase.component';
import { DashboardComponent } from './layout/dashboard/dashboard.component';
import { AngularMaterialModule } from './angular-material.module'; 
import {NgxPaginationModule} from 'ngx-pagination';
import { PaymentinfoComponent } from './layout/paymentinfo/paymentinfo.component';
import { NgxSpinnerModule ,NgxSpinnerService} from "ngx-spinner";
import { TwoDigitDecimaNumberDirective } from '../app/pipes/TwoDecimalPlaceDirective';
import { ListFilterPipe } from './pipes/list-filter.pipe';
import { CreditFilterPipe } from './pipes/credit-filter.pipe';
import { NgPreventCutCopyPasteModule } from 'ng-prevent-cut-copy-paste';
import { SalescreditNoteComponent} from './layout/salescredit-note/salescredit-note.component'
//import { NgSelectModule } from '@ng-select/ng-select';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import { NotificationListComponent } from './layout/notification-list/notification-list.component';
import { NotificationsComponent } from './layout/notifications/notifications.component';
import { ViewNotificationComponent } from './layout/view-notification/view-notification.component';
import { TdsCertificateComponent } from './layout/tds-certificate/tds-certificate.component';
import { TdsFilterPipe } from './pipes/tds-filter.pipe';



@NgModule({
  declarations: [
    AppComponent,
    TwoDigitDecimaNumberDirective,
    SigninComponent,
    PoHeaderComponent,
    LayoutComponent, 
    DateFormatPipe,
    DragDropDirective,
    CreatepurchaseComponent,
    DashboardComponent,
    PaymentinfoComponent,
    NotificationsComponent,
    NotificationListComponent,
    ViewNotificationComponent,
    ListFilterPipe,
    CreditFilterPipe,
    SalescreditNoteComponent,
    TdsCertificateComponent,
    TdsFilterPipe
  ],

  imports: [
    FormsModule,
    //NgSelectModule,
    AutocompleteLibModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    AngularMaterialModule,
    BrowserModule,
    NgxSpinnerModule,    
    NgPreventCutCopyPasteModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule, 
    //ToastrModule.forRoot(),
    ToastrModule.forRoot({
      //timeOut: 10000,
      positionClass: 'toast-top-center',
      //preventDuplicates: true,
      disableTimeOut : true,
      // timeOut: 0,
      // extendedTimeOut: 0,
      tapToDismiss: false,
      closeButton:true
    }),
    BsDatepickerModule.forRoot() 
  ],
  providers: [NgxSpinnerService],
  bootstrap: [AppComponent]
})

export class AppModule { }
